import { createRouter, createWebHistory } from 'vue-router'

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/landing',
      name: 'landing',
      component: () => import('./landing/Landing')
    },
    {
      path: '/incl-markt-comm',
      component: () => import('./landing/Landing')
    },
    {
      path: '/reseller',
      component: () => import('./landing/Landing')
    },
    {
      path: '/start',
      component: () => import('./wizard/Wizard')
    },
    {
      path: '/start-incl-markt-comm',
      component: () => import('./wizard/Wizard'),
      props: { withTaxId: true }
    },
    {
      path: '/start-reseller',
      component: () => import('./wizard/Wizard'),
      props: { withTaxId: true, reseller: true }
    },
    {
      path: '/reseller-no-comm',
      component: () => import('./landing/Landing')
    },
    {
      path: '/start-reseller-no-comm',
      component: () => import('./wizard/Wizard'),
      props: { resellerNoComm: true }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'landing' }
    }
  ]
})
